// LUMINA · pages/vajra/components/CredentialManager.jsx
// Phase 39D: extracted from VajraPortal.jsx — Phase 23 修行资质管理

import React, { useState } from 'react';
import { API, GD, CRED_KEYS, CRED_TYPE_LABELS, CRED_TYPE_COLORS } from '../constants';

export default function CredentialManager({ token, headers, memberList, loadAdminData }) {
  const [selMember, setSelMember] = useState("");
  const [creds, setCreds] = useState([]);
  const [form, setForm] = useState({credential_key:"vajrakilaya", credential_type:"empowerment", notes:""});
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const loadCreds = async (mid) => {
    if (!mid) return;
    setLoading(true);
    const d = await fetch(`${API}/vajra/staff/members/${mid}/credentials`, {headers})
      .then(r => r.ok ? r.json() : {credentials:[]});
    setCreds(d.credentials || []);
    setLoading(false);
  };

  const grant = async () => {
    if (!selMember) return setMsg("✗ 请先选择师兄");
    const r = await fetch(`${API}/vajra/staff/members/${selMember}/credentials`, {
      method:"POST", headers, body: JSON.stringify(form)
    });
    const d = await r.json();
    if (r.ok) { setMsg("✓ 资质已授予：" + (d.label_zh||"")); loadCreds(selMember); }
    else setMsg("✗ " + (d.detail||"操作失败"));
  };

  const revoke = async (credId) => {
    if (!window.confirm("确认撤销此资质？")) return;
    const r = await fetch(`${API}/vajra/staff/members/${selMember}/credentials/${credId}`, {method:"DELETE", headers});
    if (r.ok) { setMsg("✓ 资质已撤销"); loadCreds(selMember); }
    else setMsg("✗ 撤销失败");
  };

  const CR = "#8b1a1a"; const DG = "#065f46";

  return (
    <div>
      <div style={{fontSize:14, color:GD, marginBottom:16}}>修行资质管理</div>

      {/* 选择成员 */}
      <div style={{marginBottom:20}}>
        <label style={{fontSize:12, color:"#aaa", display:"block", marginBottom:6}}>选择师兄</label>
        <select value={selMember} onChange={e=>{setSelMember(e.target.value); loadCreds(e.target.value);}}
          style={{width:"100%", padding:"8px 12px", borderRadius:8, border:"1px solid #333",
            background:"#1a1a1a", color:"#ddd", fontSize:13}}>
          <option value="">— 请选择 —</option>
          {(Array.isArray(memberList)?memberList:[]).map(m=>(
            <option key={m.id} value={m.id}>{m.name}{m.dharma_name?` (${m.dharma_name})`:""} · {m.email}</option>
          ))}
        </select>
      </div>

      {selMember && (
        <>
          {/* 当前资质列表 */}
          <div style={{marginBottom:20}}>
            <div style={{fontSize:12, color:"#888", marginBottom:10}}>当前修行资质</div>
            {loading ? (
              <div style={{fontSize:12, color:"#666"}}>加载中…</div>
            ) : creds.length === 0 ? (
              <div style={{fontSize:12, color:"#555", padding:"12px", background:"#111", borderRadius:8}}>暂无资质记录</div>
            ) : (
              <div style={{display:"flex", flexDirection:"column", gap:8}}>
                {creds.map(c => (
                  <div key={c.id} style={{display:"flex", alignItems:"center", justifyContent:"space-between",
                    padding:"10px 14px", borderRadius:8, background:"#111", border:"1px solid #222"}}>
                    <div>
                      <span style={{fontSize:11, fontWeight:700, color:CRED_TYPE_COLORS[c.credential_type]||"#888",
                        background:`${CRED_TYPE_COLORS[c.credential_type]}22`, padding:"2px 8px", borderRadius:4, marginRight:8}}>
                        {CRED_TYPE_LABELS[c.credential_type]||c.credential_type}
                      </span>
                      <span style={{fontSize:13, color:"#ddd"}}>{c.label_zh}</span>
                      {c.notes && <span style={{fontSize:11, color:"#666", marginLeft:8}}>· {c.notes}</span>}
                    </div>
                    <div style={{display:"flex", alignItems:"center", gap:12}}>
                      <span style={{fontSize:11, color:"#555"}}>{c.granted_at?.slice(0,10)}</span>
                      <button onClick={()=>revoke(c.id)}
                        style={{fontSize:11, color:GD, background:"transparent", border:"none", cursor:"pointer", padding:"2px 6px"}}>
                        撤销
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* 授予新资质 */}
          <div style={{background:"#0f0f0f", border:"1px solid #222", borderRadius:10, padding:16}}>
            <div style={{fontSize:12, color:"#888", marginBottom:12}}>授予新资质</div>
            <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10}}>
              <div>
                <label style={{fontSize:11, color:"#777", display:"block", marginBottom:4}}>资质项目</label>
                <select value={form.credential_key} onChange={e=>setForm(f=>({...f,credential_key:e.target.value}))}
                  style={{width:"100%", padding:"7px 10px", borderRadius:6, border:"1px solid #333",
                    background:"#1a1a1a", color:"#ddd", fontSize:12}}>
                  {CRED_KEYS.map(k=>(
                    <option key={k.key} value={k.key}>{k.label}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{fontSize:11, color:"#777", display:"block", marginBottom:4}}>状态</label>
                <select value={form.credential_type} onChange={e=>setForm(f=>({...f,credential_type:e.target.value}))}
                  style={{width:"100%", padding:"7px 10px", borderRadius:6, border:"1px solid #333",
                    background:"#1a1a1a", color:"#ddd", fontSize:12}}>
                  <option value="empowerment">灌顶</option>
                  <option value="in_progress">修习中</option>
                  <option value="completed">已圆满</option>
                </select>
              </div>
            </div>
            <input placeholder="备注（可选）" value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))}
              style={{width:"100%", padding:"7px 10px", borderRadius:6, border:"1px solid #333",
                background:"#1a1a1a", color:"#ddd", fontSize:12, marginBottom:10, boxSizing:"border-box"}} />
            <button onClick={grant}
              style={{padding:"8px 20px", borderRadius:6, border:"none", background:GD, color:"#fff",
                fontSize:13, cursor:"pointer", fontWeight:600}}>
              授予资质
            </button>
          </div>
        </>
      )}

      {msg && <div style={{marginTop:12, fontSize:13, color:msg.startsWith("✓")?DG:CR}}>{msg}</div>}
    </div>
  );
}
